import React from 'react'

function Product1() {
  return (
    <div>Product1</div>
  )
}

export default Product1